"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

const TEXT = {
  account: "\u041a\u0430\u0431\u0438\u043d\u0435\u0442",
  signIn: "\u0412\u043e\u0439\u0442\u0438"
} as const;

export function HeaderAccountButton({ isAuthenticated }: { isAuthenticated: boolean }) {
  const pathname = usePathname();
  const isHiddenRoute =
    pathname === "/account/login" ||
    pathname === "/account/register" ||
    pathname.startsWith("/admin");

  if (isHiddenRoute) {
    return null;
  }

  return (
    <Link className="secondary-button header-login-button" href={isAuthenticated ? "/account" : "/account/login"}>
      {isAuthenticated ? TEXT.account : TEXT.signIn}
    </Link>
  );
}
